function TaxCreations() {
    return (
      <>
        <div className="font-bold text-lg mb-16">TaxCreations</div>
      </>
    );
  }
  
  export default TaxCreations;